import { actionCreator } from '@ardoq/rxbeach';

export const viewPptxExportRequested = actionCreator(
  '[viewPptxExport] Requested'
);
